module.exports = __webpack_public_path__ + "img/tubes-generator.240c0d0c.jpg";